import React, { useEffect, useState } from 'react';
import wishlistService from '../services/wishlistService';
import cartService from '../services/cartService';
import { useCurrency } from '../context/CurrencyContext';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

export default function Wishlist() {
  const { formatPrice } = useCurrency();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    let mounted = true;
    wishlistService.getWishlist().then(list => { if (mounted) setItems(list); }).catch(() => { }).finally(() => { if (mounted) setLoading(false); });
    const onUpdate = (e) => { setItems(e && e.detail && e.detail.items ? e.detail.items : []); };
    window.addEventListener('wishlistUpdated', onUpdate);
    return () => { mounted = false; window.removeEventListener('wishlistUpdated', onUpdate); };
  }, []);

  const moveToCart = async (item) => {
    try {
      await cartService.addItem({ id: item.id, name: item.name, price: item.price, image: item.image }, 1);
      await wishlistService.removeItem(item.id);
      toast.success('U zhvendos në shportë');
      nav('/cart');
    } catch (err) { console.error(err); toast.error('Dështoi zhvendosja në shportë'); }
  };

  if (loading) return <div style={{ padding: 20 }}>Duke ngarkuar listën e dëshirave...</div>;
  return (
    <div className="page-container" style={{ maxWidth: 1200, margin: '0 auto', padding: '20px' }}>
      <style>{`
        @media (max-width: 820px) {
          .wishlist-table td::before {
            display: block !important;
            font-weight: 700;
            color: #333;
            margin-bottom: 4px;
          }
          .wishlist-table td[data-label="Actions"]::before {
            display: none !important;
          }
          .wishlist-table td {
            padding: 12px 16px !important;
            border-bottom: 1px solid #f0f0f0 !important;
          }
          .wishlist-table .product-info-cell {
            display: flex !important;
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 8px !important;
          }
          .wishlist-table td[data-label="Price"] {
            display: flex !important;
            flex-direction: row !important;
            justify-content: space-between !important;
            align-items: center !important;
          }
          .wishlist-table td[data-label="Price"]::before {
            margin-bottom: 0 !important;
          }
          .wishlist-table .product-name {
            font-size: 15px !important;
          }
          .wishlist-table .cart-actions {
            display: flex !important;
            justify-content: center !important;
            width: 100%;
            gap: 8px !important;
          }

          .wishlist-table .cart-actions button {
            padding: 6px 12px !important;
            font-size: 13px !important;
          }
          .wishlist-table tr {
            margin-bottom: 12px !important;
            border: 1px solid #eee !important;
            border-radius: 8px !important;
            box-shadow: 0 2px 5px rgba(0,0,0,0.02) !important;
          }
        }
      `}</style>

      <h2 style={{ fontSize: '1.75rem', fontWeight: 700, color: '#094859', letterSpacing: '-0.4px', margin: '0 0 20px 0' }}>
        Lista ime e dëshirave
      </h2>
      {!items || !items.length ? (
        <div style={{ padding: 20, color: '#64748b', fontSize: 15 }}>Lista juaj e dëshirave është bosh. <Link to="/products" style={{ color: '#007da5', fontWeight: 600 }}>Shfletoni produktet</Link></div>
      ) : (
        <div className="table-responsive">
          <table className="cart-table wishlist-table" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 20px', minWidth: 800 }}>

            <thead>
              <tr style={{ background: '#f0f8fb', color: '#094859', textAlign: 'center', height: 48 }}>
                <th style={{ padding: '12px 16px', borderRadius: '12px 0 0 12px', textAlign: 'left', paddingLeft: 40, width: '50%', fontSize: 14, fontWeight: 700, letterSpacing: '-0.3px', borderTop: '1.5px solid #d0e7f2', borderBottom: '1.5px solid #d0e7f2', borderLeft: '1.5px solid #d0e7f2' }}>
                  Emri &amp; Përshkrimi
                </th>
                <th style={{ padding: '12px 16px', width: '20%', fontSize: 14, fontWeight: 700, letterSpacing: '-0.3px', borderTop: '1.5px solid #d0e7f2', borderBottom: '1.5px solid #d0e7f2' }}>
                  Çmimi
                </th>
                <th style={{ padding: '12px 16px', borderRadius: '0 12px 12px 0', width: '30%', fontSize: 14, fontWeight: 700, letterSpacing: '-0.3px', borderTop: '1.5px solid #d0e7f2', borderBottom: '1.5px solid #d0e7f2', borderRight: '1.5px solid #d0e7f2' }}>
                  Veprimi
                </th>
              </tr>
            </thead>
            <tbody>
              {items.map(it => (
                <tr key={it.id} style={{ background: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.03)' }}>
                  <td className="product-info-cell" data-label="Product" style={{ padding: '20px', borderBottom: '1px solid #eee', borderRadius: '12px 0 0 12px' }}>
                    <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                      <img
                        src={it.image}
                        alt={it.name}
                        style={{ width: 80, height: 80, objectFit: 'contain' }}
                      />
                      <div className="product-name" style={{ fontWeight: 700, fontSize: 15.5, color: '#1e293b', letterSpacing: '-0.3px' }}>{it.name}</div>
                    </div>
                  </td>

                  <td data-label="Price" style={{ padding: '20px', textAlign: 'center', fontWeight: 700, borderBottom: '1px solid #eee', color: '#007da5', fontSize: 16, letterSpacing: '-0.3px' }}>
                    {formatPrice(it.price || 0)}
                  </td>
                  <td data-label="Actions" style={{ padding: '20px', textAlign: 'center', borderBottom: '1px solid #eee', borderRadius: '0 12px 12px 0' }}>
                    <div className="cart-actions" style={{ display: 'flex', gap: 10, justifyContent: 'center', alignItems: 'center' }}>
                      <button
                        onClick={() => moveToCart(it)}
                        style={{
                          background: '#007da5',
                          color: '#fff',
                          border: 'none',
                          padding: '9px 18px',
                          borderRadius: 12,
                          cursor: 'pointer',
                          fontWeight: 700,
                          fontSize: 13.5,
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 8,
                          boxShadow: '0 3px 10px rgba(0, 125, 165, 0.22)',
                          transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = '#006282';
                          e.currentTarget.style.transform = 'translateY(-1px)';
                          e.currentTarget.style.boxShadow = '0 5px 16px rgba(0, 125, 165, 0.32)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = '#007da5';
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 3px 10px rgba(0, 125, 165, 0.22)';
                        }}
                      >
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="9" cy="21" r="1" />
                          <circle cx="20" cy="21" r="1" />
                          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                        </svg>
                        <span>Zhvendos në shportë</span>
                      </button>
                      <button
                        onClick={() => wishlistService.removeItem(it.id).then(list => { setItems(list); toast.success('U hoq nga lista e dëshirave'); }).catch(() => toast.error('Dështoi heqja'))}
                        style={{
                          background: '#fef6ec',
                          color: '#f7931e',
                          border: '1.5px solid #fde3c7',
                          padding: '8px',
                          borderRadius: '50%',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: 36,
                          height: 36,
                          transition: 'all 0.2s ease',
                          boxShadow: '0 2px 5px rgba(247, 147, 30, 0.08)'
                        }}
                        aria-label="Remove item"
                        title="Hiq nga lista e dëshirave"
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#f7931e';
                          e.currentTarget.style.color = '#fff';
                          e.currentTarget.style.borderColor = '#f7931e';
                          e.currentTarget.style.transform = 'scale(1.08)';
                          e.currentTarget.style.boxShadow = '0 4px 12px rgba(247, 147, 30, 0.28)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#fef6ec';
                          e.currentTarget.style.color = '#f7931e';
                          e.currentTarget.style.borderColor = '#fde3c7';
                          e.currentTarget.style.transform = 'scale(1)';
                          e.currentTarget.style.boxShadow = '0 2px 5px rgba(247, 147, 30, 0.08)';
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M3 6h18" />
                          <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                          <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                          <line x1="10" y1="11" x2="10" y2="17" />
                          <line x1="14" y1="11" x2="14" y2="17" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
